// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SITj","col":"styles_col__1Yizc"};